import { createContext } from "react";

const PayContext = createContext();

export default PayContext;
